package ai.wagemix.web.components

import ai.wagemix.web.theme.WMControlCornerVar
import ai.wagemix.web.theme.WMHairlineVar
import androidx.compose.runtime.Composable
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.dom.Iframe

/** The embedded file: it takes the height the dialog's title and actions leave. */
val WMFilePreviewFrameStyle = CssStyle.base {
    val colors = colorMode.toPalette().fs
    Modifier
        .display(DisplayStyle.Block)
        .border(WMHairlineVar.value(), LineStyle.Solid, colors.outlineVariant)
        .borderRadius(WMControlCornerVar.value())
        .backgroundColor(colors.surfaceContainer)
}

/** What [WMFilePreviewDialog] says. */
data class WMFilePreviewStrings(
    /** Under the title: what to do when the browser cannot show the file (most phones). */
    val hint: String,
    /** The embedded frame's accessible name, before the file name. */
    val frameTitle: String,
    val close: String,
    val download: String
)

/**
 * A stored file shown in the browser's own viewer before the user downloads it. The dialog is a sheet, sized by the
 * viewport, and the file fills it under the title. [previewUrl] must let the browser show the file inline; Download
 * calls [onDownload], which saves it.
 */
@Composable
fun WMFilePreviewDialog(
    fileName: String,
    previewUrl: String,
    strings: WMFilePreviewStrings,
    modifier: Modifier = Modifier,
    onDismiss: () -> Unit,
    onDownload: () -> Unit
) {
    WMDialog(
        title = fileName,
        description = strings.hint,
        variant = WMSheetDialogVariant,
        modifier = modifier,
        onDismiss = onDismiss,
        actions = {
            WMButton(
                strings.close,
                kind = WMButtonKind.Ghost,
                modifier = WMDialogButtonStyle.toModifier(),
                onClick = onDismiss
            )
            WMButton(
                strings.download,
                modifier = WMDialogButtonStyle.toModifier(),
                leadingIcon = WMIconGlyph.Download,
                onClick = onDownload
            )
        }
    ) {
        Iframe(
            attrs = WMFilePreviewFrameStyle.toModifier()
                .then(WMDialogFillStyle.toModifier())
                .toAttrs {
                    attr("src", previewUrl)
                    attr("title", "${strings.frameTitle} $fileName")
                }
        )
    }
}
